import config from 'config'
import store from '@/StoreWeb/store/store'
import router from '@/router/router'
import NavigationGuardManager from '@/StoreWeb/managers/NavigationGuardManagerSingleton'
import * as cartMutationTypes from '@/StoreWeb/store/modules/cart/mutation-types'
import * as mainMutationTypes from '@/StoreWeb/store/modules/main/mutation-types'
import * as userMutationTypes from '@/StoreWeb/store/modules/user/mutation-types'
import { isEmpty } from 'global-utils'

const navigationGuardManager = NavigationGuardManager.getInstance()

export const isSegmentBelongsToNonLocalizedRoute = (segment) => {
    return ['externalLinks', 'internalLinks'].includes(segment)
}

export const resetStates = () => {
    store.commit(mainMutationTypes.SET_SHOW_MODAL, false)
    store.commit(mainMutationTypes.SET_SHOW_MAIN_NAV, false)
    store.commit(userMutationTypes.SET_SHOW_NOTIFICATIONS, false)
    store.commit(userMutationTypes.SET_SHOW_ACCOUNT_NAV, false)
    store.commit(userMutationTypes.SET_SHOW_ACCOUNT_NAV, false)
    store.commit(cartMutationTypes.SET_SHOW_CART, false)
}

export const updateLocalizedRouteSegmentsLocaleAndGetNewPath = (segments, newLocale) => {
    segments[1] = newLocale

    return segments.join('/')
}

export const resolveUnlocalizedLocalizedRouteSegmentsAndGetResolvedRoute = (segments, localeToApply) => {
    segments = [localeToApply, ...segments.slice(1)]

    const localizedPath = '/' + segments.join('/')

    const resolvedRoute = router.resolve(localizedPath)

    if (resolvedRoute.name !== 'error404') {
        return localizedPath
    }

    return false
}

export const resolveLocalizedRouteSegmentsAndGetResolvedRoute = (path) => {
    const [pathWithoutQueryParams] = path.split('?')
    const resolvedRoute = router.resolve(pathWithoutQueryParams)

    if (resolvedRoute.name !== 'error404') {
        return resolvedRoute
    }

    return false
}

export const checkAuthorizationsAndGetFinalRoute = (to) => {
    const isAuthorisedInGuestMode = navigationGuardManager.isAuthorisedInGuestModeRoute(to.name)
    const isAuthorizedInPaymentProcessingFlow = navigationGuardManager.isAuthorizedInPaymentProcessingRoute(to.name)
    const isAuthorizedWithEmptyCart = navigationGuardManager.isAuthorizedWithEmptyCartRoute(to.name)
    const isAuthorizedRoute = navigationGuardManager.isAuthorizedRoute(to.name)

    if (!isAuthorizedRoute) {
        return {
            changeForRoute: {
                name: 'home'
            }
        }
    }

    if (!isAuthorisedInGuestMode) {
        if (config.userweb.login_mode && config.userweb.login_mode === 'kas') {
            return {
                hasToLogIn: true
            }
        } else {
            return {
                changeForRoute: {
                    name: 'home'
                }
            }
        }
    } else if (!isEmpty(to.params) && !isEmpty(to.params.hasToRefresh)) {
        return {
            hasToRefresh: true
        }
    } else if (!isAuthorizedWithEmptyCart) {
        return {
            changeForRoute: {
                name: 'home'
            }
        }
    } else if (!isAuthorizedInPaymentProcessingFlow) {
        return {
            changeForRoute: {
                name: 'cartConfirmation'
            }
        }
    }

    return {
        allChecksPassed: true
    }
}

export const getError404Route = (locale) => {
    return {
        name: 'error404',
        params: {
            lang: locale
        },
        query: {
            path: window.location.href
        },
        meta: {
            layout: 'default'
        }
    }
}
